module.exports = __webpack_public_path__ + "img/img-today.d04564db.png";